<template>
  <el-dialog title="修改订单信息" :visible.sync="dialogVisible" :before-close="closeDialog" width="600px" :close-on-click-modal="false">
    <el-form :model="form" label-width="150px" ref="ruleForm" :rules="rules">
      <template v-if="rowInfo.editStatus == 'edit'">
        <el-form-item label="收件人姓名" prop="receiveName">
          <el-input v-model.trim="form.receiveName" disabled class="y-w-300"></el-input>
        </el-form-item>
        <el-form-item label="收件人手机" prop="receiveMobile" ref="receiveMobile">
          <el-input v-model.trim="form.receiveMobile" class="y-w-300" :maxlength="11" clearable></el-input>
        </el-form-item>
        <el-form-item label="收件人电话" prop="receivePhone" ref="receivePhone">
          <el-input v-model.trim="form.receivePhone" class="y-w-300" :maxlength="20" clearable></el-input>
        </el-form-item>
      </template>
      <template v-else>
        <div class="y-mb-20">当前消费者期望上门时间已过可服务时间，请与消费者沟通后重新选择上门取件时间</div>
      </template>
      <el-form-item :label="rowInfo.editStatus == 'edit' ? '取件时间' : '上门取件时间'" prop="reciveTime">
        <selectTime
          ref="selectTime"
          class="y-w-300"
          :typeFlag="form.pickupOrderChannel=='0' ? '1' : '2'"
          :curTime="form.reciveTime"
          :receiveAddressInfo="receiveAddressInfo"
          @selectedTime="selectedTimeFn"
        ></selectTime>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="modifyFn">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import selectTime from './selectTime';
import moment from 'moment';
import { againConfirmOrderApi, confirmOrderApi, decryptUserInfoApi } from '@/api/waybillPrint/returnPickupPrint'
import { changeSpecialOrderApi } from '@/api/waybillPrint/sepecialOrderPrint'
export default {
  name: "record-list",
  components: {
    selectTime
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    rowInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    let valiMobile = (rule, value, callback) => {
      console.log('value====', value)
      if (!this.form.receiveMobile && !this.form.receivePhone) {
        return callback(new Error('手机号或电话至少填写一个！'));
      } else {
        if (
          !(/(^1\d{10}$)/.test(value) || /(^([5|6|9])\d{7}$)/.test(value)) &&
          value !== ''
        ) {
          return callback(new Error('手机号格式不正确'));
        } else {
          if (
            (value !== '' &&
              this.form.receivePhone !== '' &&
              !/^[\d-]+$/.test(this.form.receivePhone)) ||
            (value === '' && this.form.receivePhone !== '')
          ) {
            callback();
            this.$nextTick(() => {
              if (this.$refs['receiveMobile']) {
                this.$refs['receiveMobile'].clearValidate();
              }
            });
          } else {
            callback();
            this.$nextTick(() => {
              if (this.$refs['receiveMobile']) {
                this.$refs['receiveMobile'].clearValidate();
              }
              if (this.$refs['receivePhone']) {
                this.$refs['receivePhone'].clearValidate();
              }
            });
          }
        }
      }
    };
    let valiPhone = (rule, value, callback) => {
      if (!this.form.receiveMobile  && !this.form.receivePhone) {
        return callback(new Error('手机号或电话至少填写一个！'));
      } else {
        if (value !== '' && !/^[\d-]+$/.test(value)) {
          return callback(new Error('电话号码由数字和-组成！'));
        } else if (
          value !== '' &&
          /^[\d-]+$/.test(value) &&
          value.length > 20
        ) {
          return callback(new Error('电话号码长度不超过20个字符！'));
        } else {
          if (
            (value !== '' &&
              this.form.receiveMobile !== '' &&
              !(
                /(^1\d{10}$)/.test(this.form.receiveMobile) ||
                /(^([5|6|9])\d{7}$)/.test(this.form.receiveMobile)
              )) ||
            (value === '' && this.form.receiveMobile !== '')
          ) {
            callback();
            this.$nextTick(() => {
              if (this.$refs['receivePhone']) {
                this.$refs['receivePhone'].clearValidate();
              }
            });
          } else {
            callback();
            this.$nextTick(() => {
              if (this.$refs['receiveMobile']) {
                this.$refs['receiveMobile'].clearValidate();
              }
              if (this.$refs['receivePhone']) {
                this.$refs['receivePhone'].clearValidate();
              }
            });
          }
        }
      }
    };
    return {
      dialogVisible: this.isShow,
      form: {
        receiveName: '',
        receiveMobile: '',
        receivePhone: '',
        reciveTime: [],
        pickupOrderChannel: '0', // 默认给当日取
      },
      rules: {
        receiveName: [
          { required: true, message: '请输入寄件人姓名', trigger: 'blur' },
        ],
        receiveMobile: [
          { validator: valiMobile, trigger: ['blur', 'change'] },
        ],
        receivePhone: [
          { validator: valiPhone, trigger: ['blur', 'change'] },
        ],
        reciveTime: [
          { required: true, message: '请选择取件时间', trigger: ['change', 'blur'] }
        ]
      },
      receiveAddressInfo: '',
    };
  },
  methods: {
    init() {
      this.receiveAddressInfo = `${this.rowInfo.receiveProvince}|${this.rowInfo.receiveCity}|${this.rowInfo.receiveCounty}`;
      this.form = {
        receiveName: this.rowInfo.receiveName,
        receiveMobile: this.rowInfo.receiveMobile || '',
        receivePhone: this.rowInfo.receivePhone || '',
        pickupOrderChannel: this.rowInfo.pickupOrderChannel,// 默认给当日取
        reciveTime: [], // 暂时给今天当日取
      }
      if (this.rowInfo.editStatus == 'edit') {
        let loadingMask = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)',
        });
        decryptUserInfoApi({...this.rowInfo, decryptType: '2'}).then(res => {
          loadingMask.close();
          if (res.success && res.data) {
            this.form.receiveName = res.data.receiveName || '';
            this.form.receiveMobile = res.data.receiveMobile || '';
            this.form.receivePhone = res.data.receivePhone || '';
          }
        }).catch((err) => {
          loadingMask.close();
        })
      }
      
    },
    modifyFn() {
      if (this.form.pickupOrderChannel=='2' && !this.form.reciveTime.length) {
        this.form.reciveTime = this.$refs.selectTime.selectedTime;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log('this.form', this.form)
          if (this.rowInfo.editStatus == 'edit') {
            this.editConfirmFn();
          } else {
            this.auditConfirmFn();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 审核通过下单
    auditConfirmFn() {
      let params = {
        pickupOrderNo: this.rowInfo.pickupOrderNo,
        dayFlag: this.form.reciveTime[0],
        timeRange: this.form.reciveTime[1]
      };
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)',
      });
      let apiUrlFn = this.rowInfo.waybillStatus == '-10' ? againConfirmOrderApi : confirmOrderApi;
      apiUrlFn(params).then(res => {
        loadingMask.close();
        if (res.success && res.data && res.data.success ) {
          this.$message.success('下单成功');
        } else {
          this.$message.error(res.message || res.data.failMsg || '下单失败')
        }
        this.closeDialog('refresh');
      }).catch((err)=>{
        loadingMask.close();
        this.$message.error(err.message || '网络异常，请稍候重试')
      })
    },
    // 修改订单
    editConfirmFn() {
      let params = {
        pickupOrderNo: this.rowInfo.pickupOrderNo,
        waybillNo: this.rowInfo.waybillNo,
        receiveName: this.form.receiveName,
        receiveMobile: this.form.receiveMobile,
        receivePhone: this.form.receivePhone,
        dayFlag: this.form.reciveTime[0],
        timeRange: this.form.reciveTime[1],
        // userId: 'f69314be714d4aa4b9281ddecc7aff2d',
      };
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)',
      });
      changeSpecialOrderApi(params).then(res => {
        loadingMask.close();
        if (res.success && res.data && res.data.success ) {
          this.$message.success('修改成功');
          this.closeDialog('refresh');
        } else {
          this.$message.error(res.message || res.data.failMsg || '修改失败')
        }
      }).catch((err)=>{
        loadingMask.close();
        this.$message.error(err.message || '网络异常，请稍候重试')
      })
    },
    closeDialog(refresh) {
      this.dialogVisible = false;
      this.form = {
        senderName: '',
        senderMobile: '',
        reciveTime: [],
        deliveryType: '1', // 默认给当日取
      }
      this.$emit("closeDialog", refresh);
    },
    selectedTimeFn(selectedTime) {
      this.form.reciveTime = selectedTime;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-cascader.el-cascader--small {
  width: 100%;
}
/deep/ .el-dialog__footer {
  text-align: center;
}
</style>